import axios from 'axios';

export const apiInstance = axios.create({
  timeout: 30000,
  headers: {
    'X-Custom-Header': 'foobar',
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Origin': '*',
  },
});
